<template>
  <div class="services-dropdown__reservation">
    <div v-for="option in data.options" :key="`option_${option.id}`" @click="select(option)"
      :class="[`services-dropdown__people--${option.type}`, { 'selected': option.selected }]">
      <div class="option">
        <span>{{ option.title }}</span>
        <div class="option--checkbox"><Icon v-if="option.selected" icon="form-valid-check" /></div>
      </div>
      <div class="bottom">
        <span class="price">{{ option.price }}<span class="currency">zł</span></span>
        <Icon icon="couple" class="icon icon--white"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'

@Component({
  components: {
    Icon,
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
  },
})
export default class ServicePerReservation extends Vue {
  data = this.value

  get selected () {
    return this.data.options.some(option => option.selected)
  }

  get peopleCount () {
    return this.selected ? this.adultsCount + this.childrenCount + this.infantsCount : 0
  }

  get adultsCount () {
    return this.selected ? this.data.Adults : 0
  }

  get childrenCount () {
    return this.selected ? this.data.Children : 0
  }

  get infantsCount () {
    return this.selected ? this.data.Infants : 0
  }
  
  get totalPrice () {
    return this.selected ? this.data.ServicePriceAll : 0
  }

  handleOptionToggle (option) {
    option.selected = !option.selected
  }
  
  updateServiceSelectedData () {
    this.data.selected = this.selected
    this.data.selectedPeople = this.peopleCount
    this.data.selectedAdults = this.adultsCount
    this.data.selectedChildren = this.childrenCount
    this.data.selectedInfants = this.infantsCount
    this.data.selectedTotalPrice = this.totalPrice
    this.data.selectedIDs = '' // Empty means & is treated as selected for all
  }

  select (option) {
    this.handleOptionToggle(option)
    this.updateServiceSelectedData()
  }
}
</script>

<style lang="scss" scoped>
.services-dropdown__reservation {
  display: grid;
  grid-column-gap: 10px;
  text-transform: uppercase;
  font-family: 'Gotham';
  font-weight: bold;
  padding: 10px 20px 0;

  @include mediaFluid(tablet) {
    grid-template-columns: repeat(4, 200px);
    margin-bottom: 10px;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    height: 61px;
    position: relative;
    color: #005CA9;
    cursor: pointer;
    overflow: hidden;
    padding: 0;
    align-items: center;

    @include mediaFluid(tablet) {
      height: 130px;      
      border: 2px solid #fff;
      padding: 20px 20px 3px 8px;
      align-items: flex-start;
      flex-direction: column;
    }

    @include mediaFluid(desktop) {
      &:hover {
        box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.20);
      }
    }
    
    &:first-child {
      background-color: transparent;
    }
  }

  .selected {
    border-color: #005CA9;
  }

  .option {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;
    font-size: 13px;
    z-index: 1;

    @include mediaFluid(tablet) {
      align-items: flex-start;
      flex-direction: row;
      font-size: 14px;
    }

    &--checkbox {
      width: 15px;
      height: 15px;
      padding: 2px 1px;
      border: 2px solid;
      font-size: 7px;
      margin-right: 9px;

      @include mediaFluid(tablet) {
        margin: 0;
      }
    }
  }

  .price {
    font-size: 1.9em;
    z-index: 1;
    position: relative;

    @include mediaFluid(tablet) {
      font-size: 2.1em;
    }
  }

  .currency {
    font-size: 13px;
    font-family: 'Gotham Book';
    font-weight: normal;
    margin-left: 2px;
  }

  .icon {
    position: absolute;
    bottom: -18px;
    right: 78px;
    font-size: 73px;
    color: #ededed;

    @include mediaFluid(tablet) {
      font-size: 94px;
      bottom: -20px;
      right: 0;
    }
  }

  .icon--white {
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/booking/additionalServices/ServicePerReservation.vue